import React from "react";
import { useTranslation } from 'react-i18next';


export default function ProductPoints(props) {
    const { t } = useTranslation();
    let { settings, product } = props;

    if (product.isBom === true && !product.stockItemCode)
        return <></>;

   let points = product.points === undefined ? 0 : product.points,
    repPoints = product.representativePoints === undefined ? 0 : product.representativePoints;
    const pointsElem = (settings && settings.isCatalogueMode === true)
        ? (<span className="enjopure-msg"> {`${t("This product is")} ${repPoints} ${t("points towards representative points.")}`} </span >)
        : (<span className="enjopure-msg">
            {`${t("This product is")} ${points} ${t("points towards being an ENJOpure customer.")}`}
        </span>) ;
    return (
        <p>
            <svg className="enjopure-ico" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70.000 62.000"
                height="62.000" width="70.000" stroke="#000">
                    <desc>shared/enjopure/home_house</desc>
                    <defs>
                        <clipPath id="svg0v25095a">
                            <path d="M0 60h60V0H0z"></path>
                        </clipPath>
                </defs>
                <g clipPath="url(#svg0v25095a)" transform="matrix(1.33333 0 0 -1.33333 -5.403 75.1)" stroke="#43d9a3" strokeWidth="3">
                        <path d="M0 0v-25.095a.96.96 0 0 0-.96-.96h-34.56a.96.96 0 0 0-.96.96V-.022" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 48.76 36.522)"></path>
                        <path d="M0 0v5.42c0 .53.43.96.96.96h2.88c.53 0 .96-.43.96-.96v-9.447" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 43.902 44.33)"></path>
                        <path d="M0 0l25.106-21.066a.96.96 0 0 0 .118-1.353l-.617-.735a.958.958 0 0 0-1.352-.118L0-3.76l-23.255-19.512a.958.958 0 0 0-1.352.118l-.617.735a.96.96 0 0 0 .118 1.353z" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 30.304 55.669)"></path>
                        <path d="M0 0v12" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 30.304 15.621)"></path>
                        <path d="M0 0c-1.242-1.206-2.4-3.165-2.4-5.52 0-2.355 1.158-4.314 2.4-5.52 1.242 1.206 2.4 3.165 2.4 5.52C2.4-3.165 1.242-1.206 0 0z" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 30.304 38.787)"></path>
                        <path d="M0 0c.125-1.727.882-3.873 2.686-5.387C4.49-6.9 6.735-7.272 8.457-7.097 8.332-5.37 7.575-3.224 5.771-1.71 3.967-.196 1.722.176 0 0z" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 17.283 29.879)"></path>
                        <path d="M0 0l4.413-3.702" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 25.84 22.743)"></path>
                        <path d="M0 0c-.125-1.727-.882-3.873-2.686-5.387C-4.49-6.9-6.735-7.272-8.457-7.096c.125 1.726.882 3.872 2.686 5.386C-3.967-.195-1.722.177 0 0z" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 43.325 29.877)"></path>
                        <path d="M0 0l-4.413-3.703" fill="none" strokeMiterlimit="10" transform="matrix(1.01178 0 0 1.00548 34.769 22.742)"></path>
                    </g>
            </svg>
             
            {pointsElem}
        </p>
    );
}
